import * as Sentry from '@sentry/react';

// No-op if DSN not configured
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: true,      // mask user text for privacy
        blockAllMedia: false,
      }),
    ],
    tracesSampleRate: 0.1,      // 10% of navigations get performance traces
    replaysSessionSampleRate: 0, // don't record normal sessions
    replaysOnErrorSampleRate: 1, // always record session replay when an error occurs
  });
}

export default Sentry;
